import { CustomVariableDto } from '../dtos/CustomVariable.dto'

export class Farm {
	constructor(
		readonly name: string,
		readonly city: string,
		readonly country: string,
		readonly active?: boolean,
		readonly code?: number,
		readonly registration?: string,
		readonly description?: string,
		readonly customVariables?: CustomVariableDto[],
		readonly area?: number,
		readonly tenant?: string,
		readonly neighborhood?: string,
		readonly zipcode?: string,
		readonly address?: string,
		readonly state?: string,
		readonly owner?: string,
		readonly reference?: string,
		readonly id?: string,
		readonly hasRegistryDependency?: boolean,
	) {}
}
